<template>
  <div>
    <div class="row page-titles">
      <div class="col-md-12 align-self-center">
        <h4 class="text-themecolor">{{ $t('User Area') }}</h4>
      </div>
    </div>
    <div class="row">
      <!-- Column -->
      <div class="col-lg-4 col-xlg-3 col-md-5">
        <div class="card">
          <div class="card-body">
            <div class="m-t-30 text-center"> <img :src="currentUserImage()" alt="user" class="img-circle" width="150">
              <h4 class="card-title m-t-10">{{ currentUser.name }}</h4>
            </div>
          </div>
          <div>
            <hr> </div>
          <div class="card-body">
            <small class="text-muted">{{ $t('Email address') }} </small>
            <h6>{{ currentUser.email }}</h6>
          </div>
        </div>
      </div>
      <!-- Column -->
      <div class="col-lg-8 col-xlg-9 col-md-7">
        <div class="card">
          <!-- Nav tabs -->
          <slot name="profileNavigation" />
          <!-- Tab panes -->
          <div class="tab-content">
            <div class="tab-pane active" id="home" role="tabpanel">
              <div class="card-body">
                <slot />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Column -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ProfileUser",
  computed: {
    ...mapGetters({
      user: "auth/user",
      loading: "auth/loading",
      error: 'auth/error'
    }),
    currentUser() {
      return this.user || {};
    },
  },
  methods: {
    currentUserImage() {
      return this.currentUser.profileImg || `https://ui-avatars.com/api/?name=${this.currentUser.name}`;
    },
  }
};
</script>
